module.exports = {
  props: ['images', 'previewImages', 'currentIndex', 'left'],


  data () {
    return {
      zoom: 1,
      dragging: false,
      x: 0,
      y: 0,

      transform: {
        x: 0,
        y: 0
      },

      translate: 'translate(0px, 0px)'
    }
  },

  computed: {
    scale () {
      return `transform: scale(${this.zoom}) ${this.translate}`
    }
  },

  mounted () {
    var slideCount = this.images.length

    var sliderManager = new Hammer.Manager(document.querySelector('#swipe-modal'))

    sliderManager.add(new Hammer.Pan({ threshold: 0, pointers: 0 }))

    sliderManager.on('pan', e => {
      var percentage = 100 / slideCount * e.deltaX / window.innerWidth

      if (e.isFinal) { 
        if (percentage < 0) {
          this.move(1);
        } else if (percentage > 0) {
          this.move(-1);
        } else {
          this.move(0);
        }
      }
    });
  },

  methods: {
    move(num){
      if ((this.currentIndex === 0 && num === -1) || (this.currentIndex >= this.images.length -1 && num === 1) || this.zoom !== 1) return

      this.x = this.y = 0
      this.$emit('move', num)
      this.transform = {  x: 0, y: 0 }
      this.translate = 'translate(0px, 0px)'
      this.zoom = 1
    },

    close () {
      this.$emit('close')
    },

    url (image, index) {
      return this.previewImages >= index ? image : ''
    },

    startDrag (e) {
      if (this.zoom !== 1) {
        const touch = e.touches[0]
        this.x = touch.clientX;
        this.y = touch.clientY;
      }
      this.dragging = true;
    },

    stopDrag (e) {
      if (this.zoom !== 1) {
        this.transform = {
          x: e.changedTouches[0].clientX - this.x + this.transform.x,
          y: e.changedTouches[0].clientY - this.y + this.transform.y,
        }
      }
      this.dragging = false;
    },

    doDrag (e) {
      const touch = e.touches[0]

      if (this.dragging && this.zoom !== 1) {
        this.translate = `translate(${touch.clientX - this.x + this.transform.x}px, ${touch.clientY - this.y + this.transform.y}px)`
      }
    },

    zoomHandle (value) {
      if (value === 1) {
        this.x = this.y = 0
        this.transform = {  x: 0, y: 0 }
        this.translate = 'translate(0px, 0px)'
      }
      this.zoom = value
    }
  },
 
  template: `
    <div class="book-preview__modal">
      <div class="backdrop" @click="close"></div>

      <div class="flex justify-content-center align-items-center w-100">

        <div class="book-preview__slider" id="swipe-modal">
          <div class="book-preview__slider-wrapper" :style="left">
            <div class="book-preview__slider-item book-preview__slider-item--isModal" v-for="(image, index) in images">
              <img 
                @touchend="stopDrag"
                @touchstart="startDrag" 
                @touchmove.passive="doDrag" 
                :style="currentIndex === index ? scale : ''" 
                :src="url(image, index)" 
              />
            </div>
          </div>
        </div>

        <div class="book-preview__arrow-left" @click="move(-1)">
          <i class="fas fa-sort-up book-preview__arrow-left--left"></i>
        </div>

        <div class="book-preview__arrow-right" @click="move(1)">
          <i class="fas fa-sort-up book-preview__arrow-right--right"></i>
        </div>

        <div class="book-preview__zoom-controls">
          <i class="fas fa-search-plus mx-2" :class="{'h-text-grey-cl-400': zoom !== 1 }" @click="zoomHandle(1.3)"></i>
          <i class="fas fa-search-minus mx-2" :class="{'h-text-grey-cl-400': zoom === 1 }" @click="zoomHandle(1)"></i>
          <i class="fas fa-times-circle text-white mx-2" @click="close" ></i>
        </div>
      </div>
    </div>
  `
}

